import { Injectable } from '@angular/core';
import { IPagination } from '../../../../shared/services/api/interface/pagination.interface';
import { Observable } from 'rxjs';
import { ApiService } from '../../../../shared/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class SmsTemplateService {
  constructor(private readonly apiService: ApiService) {}

  getAll() {
    return this.apiService.get<any>('sms-template');
  }

  getAllFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(
      `sms-template/filter-list`,
      { event: event, filter: filter }
    );
  }

  create(data: any) {
    return this.apiService.post('sms-template/create', data);
  }

  update(data: any) {
    return this.apiService.put('sms-template/update', data);
  }

  delete(id: number) {
    return this.apiService.delete(`sms-template/delete/${id}`);
  }
}
